export const orderStatus = {
  NEW: { type: 'ok', description: 'Pedido criado' },
  AP: { type: 'ok', description: 'Pagamento confirmado' },
  PG: { type: 'ok', description: 'Pagamento confirmado' },
  NP: { type: 'warning', description: 'Pagamento Recusado' },
  BAP: { type: 'warning', description: 'Aguardando pagamento' },
  PW: { type: 'warning', description: 'Aguardando pagamento' },
  PAV: { type: 'ok', description: 'Pagamento após vencimento' },
  C: { type: 'denied', description: 'Pedido Cancelado!' },
  CM: { type: 'denied', description: 'Cancelado Manualmente' },
  CBS: { type: 'denied', description: 'Pedido e Boleto cancelados!' },
  CES: { type: 'ok', description: 'Pedido Cancelado e estornado' },
  PP: { type: 'ok', description: 'Pedido em preparação' },
  PF: { type: 'ok', description: 'Pedido finalizado, aguardando expedição' },
  PT: { type: 'ok', description: 'Pedido entregue na transportadora' },
  PET: { type: 'ok', description: 'Pedido em trânsito' },
  PE: { type: 'ok', description: 'Pedido entregue' },
  DV: { type: 'denied', description: 'Pagamento divergente' },
  null: { type: 'warning', description: 'Pagamento recusado' },
}

